import { render, staticRenderFns } from "./resort-table.vue?vue&type=template&id=ecfc5918&lang=pug&"
import script from "./resort-table.vue?vue&type=script&lang=js&"
export * from "./resort-table.vue?vue&type=script&lang=js&"
import style0 from "./resort-table.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VSimpleTable } from 'vuetify/lib/components/VDataTable';
installComponents(component, {VSimpleTable})
